import PitchTabs from './PitchTabs';

export default PitchTabs;
